import { css } from 'emotion';

import { colors } from '@cobliteam/base-components/src/styles/colors';
import { fonts } from '@cobliteam/base-components/src/styles/fonts';

const paperWrapper = css`
  overflow-x: hidden;
  border-top: 0;
`;

const slideWrapper = css`
  border-radius: 5px;
  background-color: ${colors.gray.light};
`;

const slideProgress = (progress: number) => css`
  height: 8px;
  border-radius: 5px;
  transition: width 1s;
  width: ${progress}%;
  background-color: ${colors.primary.default};
`;

const closeButton = css`
  position: absolute;
  top: 28px;
  right: 20px;
  z-index: 1000;
`;

const modalWidth = 720;

const slider = (slides: number, currentSlide: number) => css`
  position: relative;
  overflow-x: hidden;
  display: flex;
  padding: 0;
  margin: 0;
  transition: all 0.5s ease;
  transform: translateX(-${modalWidth * currentSlide}px);
  width: ${slides * modalWidth}px;
`;

const modalContent = css`
  width: ${modalWidth}px;
  text-align: center;
`;

const videoWrapper = css`
  width: 100%;
  height: 300px;
  object-fit: cover;
`;

const title = css`
  color: ${colors.black};
  font-weight: ${fonts.weight.medium};
  font-size: ${fonts.size.medium};
  display: block;
`;

const info = css`
  padding: 15px;
  color: ${colors.gray.dark};
  font-weight: ${fonts.weight.light};
  font-size: ${fonts.size.small};
`;

const action = css`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  border-top: 1px solid ${colors.gray.light};

  & > *:not(:last-child) {
    margin-right: 30px;
  }
`;

export default {
  paperWrapper,
  slideWrapper,
  slideProgress,
  closeButton,
  slider,
  modalContent,
  videoWrapper,
  title,
  info,
  action,
};
